module.exports = __webpack_public_path__ + "static/hf8-1-min-80bab34691b82fe583dfb0e86ab3fc03.png";